import * as Yup from 'yup';

export const schema = Yup.object().shape({
  Title: Yup.string().required('وارد کردن عنوان محصول ضروری است'),
  Desc: Yup.string().max(250, 'حداکثر کاراکتر 250 '),
  // Desc: Yup.string().required('وارد کردن توضیحات محصول ضروری است'),
  // RegisterTitle: Yup.string().required('وارد کردن ثبت نام ضروری است'),
});

export const requiredFieldsEntry = Object.entries(schema.fields).filter(([_, value]) => value?.spec?.presence === 'required');
export const requiredFields = Object.keys(Object.fromEntries(requiredFieldsEntry));
